import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const s = {
  nav: {
    background: '#111',
    color: '#fff',
    padding: '0 32px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: '56px',
    flexShrink: 0,
  },
  brand: {
    fontSize: '14px',
    fontWeight: '700',
    letterSpacing: '0.08em',
    color: '#fff',
    textDecoration: 'none',
  },
  links: {
    display: 'flex',
    gap: '24px',
    alignItems: 'center',
  },
  logoutBtn: {
    background: 'none',
    border: 'none',
    color: '#ccc',
    fontSize: '14px',
    cursor: 'pointer',
    padding: 0,
  },
};

function navLink(active) {
  return { color: active ? '#fff' : '#ccc', textDecoration: 'none', fontSize: '14px' };
}

export default function AdminNav() {
  const location = useLocation();
  const navigate = useNavigate();
  const role = localStorage.getItem('role');

  const active = (path) => location.pathname === path;

  const logout = () => {
    fetch('/api/auth/logout', { method: 'POST', credentials: 'include' });
    localStorage.clear();
    navigate('/admin/login');
  };

  return (
    <nav style={s.nav}>
      <Link to="/admin" style={s.brand}>The Real Autograph — Admin</Link>
      <div style={s.links}>
        <Link to="/admin/batches" style={navLink(active('/admin/batches'))}>Batches</Link>
        <Link to="/admin/assign" style={navLink(active('/admin/assign'))}>Assign</Link>
        {role === 'dev' && <Link to="/admin/users" style={navLink(active('/admin/users'))}>Users</Link>}
        {role === 'dev' && <Link to="/admin/history" style={navLink(active('/admin/history'))}>History</Link>}
        <Link to="/admin/settings" style={navLink(active('/admin/settings'))}>Settings</Link>
        <button onClick={logout} style={s.logoutBtn}>Sign out</button>
      </div>
    </nav>
  );
}
